var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#heart-off--oLoW+';
                    var viewUrl = 'sprites.svg#view-heart-off--oLoW+';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };